var map = {
	"./cloud-active.svg": 97440,
	"./cloud.svg": 73421,
	"./collect-active.svg": 86631,
	"./collect.svg": 47740,
	"./course-active.svg": 34200,
	"./course.svg": 95221,
	"./exist-import.svg": 37311,
	"./exist-personal.svg": 34952,
	"./more-board.svg": 44326,
	"./more-master.svg": 69656,
	"./more-max.svg": 956,
	"./more-md.svg": 89425,
	"./more-project.svg": 41689,
	"./new-empty.svg": 5864,
	"./new-flow.svg": 94645,
	"./new-gantt.svg": 90705,
	"./new-org.svg": 98197,
	"./new-plan.svg": 59108,
	"./new-uml.svg": 82425,
	"./newPage-active.svg": 9312,
	"./newPage.svg": 42189,
	"./openrecord-active.svg": 92632,
	"./openrecord.svg": 24501,
	"./sharetome-active.svg": 51713,
	"./sharetome.svg": 23170,
	"./slider-icon-en.svg": 840,
	"./slider-icon.svg": 70729,
	"./slider-new.svg": 93144,
	"./store-active.svg": 70532,
	"./store.svg": 41977,
	"./team-active.svg": 96868,
	"./team.svg": 60793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1074;